import React, { FC, useState } from 'react';
import dayjs from 'dayjs';
import {toast} from 'react-toastify';
import { AxiosError } from 'axios'

import { api } from '@/api';

import { GxButton, GxSpinner } from '@garpix/garpix-web-components-react';
import ModalLayout from '../../../../components/ModalLayout';
import TimePicker from '../TimePicker';

import styles from './styles/index.module.scss';

interface IModalExtendDeposit {
  flag: boolean,
  date: Date,
  onRequestClose: () => void;
}

const ModalFlyListBlock: FC<IModalExtendDeposit> = ({ flag, onRequestClose, date }) => {
  const [time, setTime] = useState('00:00');
  const [statusLoad, setStatusLoad] = useState(false);

  const onSave = async() => {
    setStatusLoad(true);
    const dateTimeString = `${dayjs(date).format('YYYY-MM-DD')}T${time}`;
    const utcDateTime = dayjs(dateTimeString).utc().format();
    try {
      await api.order.createFlyBlock({'start_at': utcDateTime});
      toast.success('Блок успешно создан!');
      onRequestClose();
    } catch (e) {
      const error = e as AxiosError<{start_at: string[]}>
      const message = error?.response?.data?.start_at?.[0] || 'Ошибка создания блока';
      toast.error(message);
    } finally {
        setStatusLoad(false);
    }
  }

  return (
    <ModalLayout
      flag={flag}
      onClose={() => {
        onRequestClose();
      }}
      size='s'
    >
      <div className={styles.main}>
        <h2 className={styles.main__title}>
          Создать блок
        </h2>
        <TimePicker onTimeChange={setTime}/>
      </div>
      <div className={styles.footer}>
        <GxButton
          className={styles.btn__close}
          onClick={onRequestClose}
          variant='secondary'
        >
          Отмена
        </GxButton>
        {statusLoad ? <GxSpinner
          style={{ fontSize: '2rem' }}
        /> : <GxButton
          className={styles.btn__save}
          variant='primary'
          onClick={onSave}
        >
          Сохранить
        </GxButton>}
      </div>
    </ModalLayout>
  );
};

export default ModalFlyListBlock;